type ReceiptPrinterTransport = {
	isSDK?: boolean | null;
	connectType?: string | null;
	usePrinterAgent?: boolean | null;
} | null;

/** USB receipt printer that should print through the local printer agent. */
export function usesPrinterAgentUsb(printer?: ReceiptPrinterTransport): boolean {
	return (
		printer?.isSDK === false &&
		printer?.connectType === 'USB' &&
		printer?.usePrinterAgent === true
	);
}

/** USB receipt printer that prints in the browser (same path as print bill). */
export function usesDirectWebUsb(printer?: ReceiptPrinterTransport): boolean {
	return (
		printer?.isSDK === false &&
		printer?.connectType === 'USB' &&
		printer?.usePrinterAgent !== true
	);
}

/** The outlet default. Do not fall back to another printer in the list. */
export function pickDefaultReceiptPrinter<
	T extends { isDefault?: boolean | null },
>(printers?: T[] | null): T | undefined {
	if (!printers?.length) return undefined;
	const flagged = printers.find(printer => printer?.isDefault === true);
	if (flagged) return flagged;
	if (printers.length === 1) return printers[0];
	return undefined;
}
